import { MainV3ApiBase } from './base';
import { LessonId } from '../types/lessons';

export const LessonActivationApis = {
    base() {
        return MainV3ApiBase.appendPath('users/current/lesson_activations');
    },
    create(lessonId: LessonId): Promise<void> {
        return this.base().post({ lesson_id: lessonId });
    },
};
